import React, { useState } from "react";
import {
  Form,
  Input,
  Card,
  Row,
  Col,
  Button,
  Modal,
  DatePicker,
  Alert,
  message,
  Spin,
} from "antd";
import dayjs from "dayjs";
import EndpointFunctions from "../../../utils/Functions/endpointFunctions";
import Endpoints from "../../../api/endpoints";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import MonthlyUsageCard from "./MonthlyUsageCard";

const { RangePicker } = DatePicker;

const SubscriptionInformation = ({ shop, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const handleDateRangeChange = (dates) => {
    setSelectedDates(dates);
  };

  console.log("shop", shop);

  const handleOk = async () => {
    const subscriptionData = {
      startedAt: selectedDates ? selectedDates[0]?.format("YYYY-MM-DD") : null,
      endedAt: selectedDates ? selectedDates[1]?.format("YYYY-MM-DD") : null,
      shopId: shop?.shopDetails?.id,
    };

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.addSubscription,
      axiosPrivate: axiosPrivate,
      requestBody: subscriptionData,
    });
    if (result.success) {
      message.success("Abonelik başarıyla güncellendi");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      message.error(result.message);
    }
    setIsModalOpen(false);
    setSelectedDates(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return dayjs(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  return (
    <Spin spinning={isLoading}>
      <Card
        style={{ marginTop: 16 }}
        title="Abonelik Bilgileri"
        type="inner"
        extra={
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            Abonelik Düzenle
          </Button>
        }>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item label="Abonelik Tipi">
              <Input
                value={shop?.shopSubscriptionDetails?.subscriptionType || "-"}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Abonelik Periyodu">
              <Input
                value={
                  shop?.shopSubscriptionDetails?.period?.description || "-"
                }
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Başlangıç Tarihi">
              <Input
                value={formatDate(shop?.shopSubscriptionDetails?.startDate)}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Bitiş Tarihi">
              <Input
                value={formatDate(shop?.shopSubscriptionDetails?.endDate)}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <MonthlyUsageCard
          usage={shop?.shopSubscriptionDetails?.monthlyStampUsage}
        />
      </Card>

      <Modal
        title="Abonelik Düzenle"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedDates(null);
        }}
        destroyOnClose>
        {shop?.shopSubscriptionDetails?.tier === "STARTER" && (
          <Alert
            message="Bu shop şu anda Starter (Ücretsiz) planda."
            description="Override Subscription eklediğinde Pro tier'a geçer; aylık damga limiti kalkar, ek kart ve personel eklenebilir."
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
        {shop?.shopSubscriptionDetails?.tier === "PRO" &&
          shop?.shopSubscriptionDetails?.subscriptionType === "OVERRIDE" && (
            <Alert
              message={`Bu shop şu anda Override Pro'da — bitiş tarihi: ${dayjs(
                shop.shopSubscriptionDetails.endDate
              ).format("DD.MM.YYYY")}`}
              description="Yeni bir override eklemek mevcut kaydı günceller."
              type="success"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
        {shop?.shopSubscriptionDetails?.tier === "PRO" &&
          shop?.shopSubscriptionDetails?.subscriptionType === "REVENUECAT" && (
            <Alert
              message="Bu shop RevenueCat aboneliği aktif (App Store / Play Store üzerinden ödüyor)."
              description="Override eklemen gereksiz olabilir — kullanıcı zaten Pro ücreti ödüyor."
              type="warning"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}
        <Form layout="vertical">
          <Form.Item
            label="Abonelik Tarihi Seçin"
            extra="Başlangıç ve bitiş tarihleri boş bırakılabilir">
            <RangePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
              onChange={handleDateRangeChange}
              showTime={false}
              allowEmpty={[true, true]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};

export default SubscriptionInformation;
